import { cn } from "@/lib/utils";
import { AlertTriangle } from "lucide-react";
import { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  className?: string;
};

// The tutorial's notice for anything the user has to go and fix outside this
// page — an extension to update, or one to switch back on.
export const TutorialAlert = ({ title, children, className }: Props) => (
  <div
    className={cn(
      "rounded-[15px] border border-amber-500 bg-panel-background p-4",
      "flex items-start gap-2.5",
      className,
    )}
    role="alert"
  >
    <AlertTriangle
      className="mt-0.5 size-5 shrink-0 text-amber-500"
      aria-hidden
    />
    <div className="flex flex-col gap-2">
      {/*
        A label, not a heading: role="alert" already announces the whole box,
        and one of these sits inside a step whose own title is an h3, where a
        heading would invert the outline.
      */}
      <p className="text-sm font-bold text-white">{title}</p>
      {children}
    </div>
  </div>
);
